import { httpDelete, httpGet, httpPatch, httpPost } from '../http.service'
import { IHttpResponse } from '../common.interface'

class UserService {
	async fetchListing(params?: any) {
		return await httpGet<IHttpResponse<any>>('api/v1/admin/user', params)
	}
	async create(params?: any) {
		return await httpPost<any>('api/v1/admin/user', params)
	}
	async update(id: string, params?: any) {
		return await httpPatch<any>(`api/v1/admin/user/${id}`, params)
	}
	async detail(id: string) {
		return await httpGet<any>(`api/v1/admin/user/${id}`)
	}
	async delete(id: string) {
		return await httpDelete<any>(`api/v1/admin/user/${id}`)
	}
}
const userService = new UserService()
export { userService }
